module.exports = __webpack_public_path__ + "img/Group_2.30079bc2.png";